export default class YouTubePlayer {
	constructor(el) {
		this.el = el;

		this.data = JSON.parse(this.el.dataset.ytData);
		this.playerEl = this.el.querySelector('[data-player]');
		this.overlay = this.el.querySelector('[data-yt-overlay]');
		this.hasPlayed = false;

		if (!this.playerEl) {
			return;
		}

		this.loadVideo(this.data.id);

		this.el.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}
			this.loadVideo(this.data.id);
		});

		this.overlay.addEventListener('click', (e) => {
			if (!this.player) {
				return;
			}

			this.player.playVideo();
			this.removeOverlay();
		});
	}

	loadVideo(id) {
		if (!this.player) {
			this.createplayer({
				videoId: id,
			});
		} else {
			this.player.loadVideoById(id);
			this.removeOverlay();
		}
	}

	createplayer(options) {
		this.player = new YT.Player(this.playerEl, {
			events: {
				onReady: this.ready,
			},
			playerVars: {
				modestbranding: 1,
				playsinline: 1,
				rel: 0,
				enablejsapi: 1,
				showinfo: 0,
			},
			...options,
		});
	}

	removeOverlay() {
		if (!this.hasPlayed) {
			this.el.classList.add('has-played');
			this.overlay.remove();
			this.hasPlayed = true;
		}
	}

	ready() {}
}
